<div class="overview-sector-breakdown">
  <klt-section type="none" title="Sector breakdown">
    <div class="value-box">
      @if (singleBreakdown && singleBreakdown.length > 0) {
        <div
          class="value-zone"
          >
          <ngx-charts-tree-map
            [scheme]="colorScheme"
            [results]="singleBreakdown!"
            [gradient]="gradient"
            [animations]="animations"
            [customColors]="customColors"
            [labelFormatting]="labelFormatting"
            [tooltipDisabled]="tooltipDisabled"
            >
            >
            <ng-template #tooltipTemplate let-model="model" let-i="index">
              <div class="tooltip">
                <p>{{ model.name }}</p>
                <p>{{ model.extra.display }} ({{ model.extra.percentage }}%)</p>
              </div>
            </ng-template>
          </ngx-charts-tree-map>
        </div>
      }
      @if (singleBreakdown.length == 0) {
        <div class="graph-loader">
          <div class="inner">
            <div class="loader"></div>
          </div>
        </div>
      }
    </div>
  </klt-section>
</div>
